import { useMemo } from 'react';

import { useClient } from 'urql';
import { fromPromise } from 'xstate5';

import {
  ReceiptDocument,
  type ReceiptQuery,
  type ReceiptQueryVariables,
} from '../../../GraphQL/Receipt.generated';
import { FetchReceiptInput, FetchReceiptResponse } from '../../receipt.machine.types';

// ─────────────────────────────────────────────────────────────────────────────

export const useFetchReceiptActor = () => {
  const client = useClient();

  const fetchReceipt = useMemo(
    () =>
      fromPromise<FetchReceiptResponse, FetchReceiptInput>(async (event) => {
        const response = await client
          .query<ReceiptQuery, ReceiptQueryVariables>(
            ReceiptDocument,
            { id: event.input.receiptId },
            { requestPolicy: 'network-only' },
          )
          .toPromise();

        const receipt = response?.data?.receipt;

        if (!receipt) {
          throw new Error(response?.error?.message ?? 'No receipt data');
        }

        const errorMessage = receipt.__typename === 'Receipt' ? null : receipt.errorMessage;

        return {
          result: receipt.__typename,
          receipt: receipt,
          errorMessage,
        };
      }),
    [client],
  );

  return {
    fetchReceipt,
  };
};
